export default function ArrowRight({ className, fill = '#FFFFFF' }) {
  return (
    <svg
      className={className || ''}
      width="23"
      height="22"
      viewBox="0 0 23 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_178_414)">
        <path
          d="M1.59523 11L21.4048 11"
          stroke={fill || ''}
          strokeWidth="1.52381"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.0714 16.3334L21.4048 11.0001L16.0714 5.66675"
          stroke={fill || ''}
          strokeWidth="1.52381"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_178_414">
          <rect
            width="21.3333"
            height="21.3333"
            fill={fill || ''}
            transform="translate(0.833332 0.333374)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
